import { $applyNodeReplacement, type EditorConfig, ParagraphNode, SerializedParagraphNode } from 'lexical';

export type SerializedCustomParagraphNode = SerializedParagraphNode;

export class CustomParagraphNode extends ParagraphNode {
  static getType(): string {
    return 'custom-paragraph';
  }

  static clone(node: CustomParagraphNode): CustomParagraphNode {
    return new CustomParagraphNode(node.__key);
  }

  static importJSON(serializedNode: SerializedCustomParagraphNode): CustomParagraphNode {
    const node = $createCustomParagraphNode();
    node.setFormat(serializedNode.format);
    node.setIndent(serializedNode.indent);
    node.setDirection(serializedNode.direction);
    node.setTextFormat(serializedNode.textFormat);
    return node;
  }

  exportJSON(): SerializedCustomParagraphNode {
    return {
      ...super.exportJSON(),
      type: 'custom-paragraph',
    };
  }

  createDOM(config: EditorConfig): HTMLElement {
    const dom = document.createElement('span');

    // Debug classname
    dom.classList.add('custom-paragraph-node');

    // Apply paragraph theme to this node
    const themeClassName = config.theme.paragraph;
    if (themeClassName !== undefined) {
      dom.classList.add(themeClassName);
    }

    // Mimic a p tag
    dom.style.display = 'block';
    return dom;
  }
}

function $createCustomParagraphNode(): CustomParagraphNode {
  const customParagraphNode = new CustomParagraphNode();
  return $applyNodeReplacement(customParagraphNode);
}
